import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, interval, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-new-onboarding-process',
  templateUrl: './new-onboarding-process.component.html',
  styleUrls: ['./new-onboarding-process.component.scss']
})
export class NewOnboardingProcessComponent implements OnInit {
  checked: any;
  showButton: boolean = true;

  constructor(private router :Router) { }

  showSalyLogo: boolean = false;

  // SignUp
  private destroy$: Subject<void> = new Subject<void>();

  variants = [
    { image: 'assets/img/Bussiness Registration.png', content: 'Business Registration',step:'Step 1' },
    { image: 'assets/img/Payment Purpose.png' ,content: 'Payment Purpose',step:'Step 2'},
    { image: 'assets/img/Bussiness Bank Details.png' ,content: 'Business Bank Details',step:'Step 3'},
    { image: 'assets/img/Bussiness Overview.png' , content: 'Business Overview',step:'Step 4'},
    { image: 'assets/img/Document Verification.png',content: 'Document Verification' ,step:'Step 5'},
    { image: 'assets/img/Agreement E-Sign.png' ,content: 'Agreement  E-Sign',step:'Step 6'},
  ];

  currentStep = 0;

  ngOnInit() {
    this.autoScroll();


    if(environment.production)
      { 
        window.location.href ="https://fastswiff.com/merchant/#/registration/NewSignup";
      }
      else{
        window.location.href ="https://fastswiff.com/merchant/#/registration/NewSignup";
      }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  handleChange(value:any){
    this.checked = value;
    if(this.checked ==true){
      this.showButton = false;
    }
    else{
      this.showButton = true;
    }
  }
  autoScroll() {
    interval(2000) // Adjust the duration (3 seconds in this example)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.nextStep();
      });
  }
  signUpClick(){
    this.router.navigate([`/onboarding`]);
  }
  onSignIn(){
    this.router.navigate([`/newlogin`]);
  }
  nextStep() {
    this.currentStep = (this.currentStep + 1) % this.variants.length;
  }

  prevStep() {
    this.currentStep = (this.currentStep - 1 + this.variants.length) % this.variants.length;
  }
  goToStep(step: number) {
    this.currentStep = step;
  }


}
